module.exports = __webpack_public_path__ + "static/about-one-small-929d06b487074a355f780899c08c50a3.webp";